/*                                                   */
import type Stores from "@kestrel/stores";
import { getContext } from "svelte";
import { writable } from "svelte/store";
import { noop } from "@otto-ec/assets-core-utils/misc";
import type { ResolvedComponent } from "@kestrel/internal/client";
import type { SSRData } from "@kestrel/template";
import { clientOnly } from "../../utils/universal";
import { loadData, reloadData } from "./loadData";

/**
 *
 */
export const clientContext = "__kestrel__" as const;

/**
 *
 *
 *
 *
 *
 *
 */
export const createStores = (
  state: SSRData,
  resolvedComponent: ResolvedComponent | undefined,
  onex: Record<string, string> = {},
): Stores.KestrelStores => ({
  initial: writable(state),
  data: writable(state.data),
  form: writable(state.form),
  error: writable(state.error),
  routeId: writable(state.routeId),
  routePath: writable(state.routePath),
  navigate: writable([state.routeId, state.routePath, state.data, state.error, noop]),
  component: writable(resolvedComponent),
  onex: writable(onex),
});

/**
 *
 */
export const getStores: typeof Stores.getStores = () =>
  getContext<Stores.KestrelStores>(clientContext);

/**
 *
 */
export const data: (typeof Stores)["data"] = {
  subscribe: (run, invalidate) => getStores().data.subscribe(run, invalidate),
};

/**
 *
 */
export const useLoadData: typeof Stores.useLoadData = clientOnly(() => loadData.bind(getStores()));

/**
 *
 */
export const useReloadData: typeof Stores.useReloadData = clientOnly(() =>
  reloadData.bind(getStores()),
);
